<div class="modal-content" style="position: sticky;">
    <ngx-ui-loader loaderId="book-facilitys-loader"></ngx-ui-loader>
    <form *ngIf="meetingForm" [formGroup]="meetingForm" class="form fv-plugins-bootstrap5 fv-plugins-framework"
        id="kt_modal_add_event_form">
        <div class="modal-header">
            <h2 class="fw-bolder" data-kt-calendar="title">Book Facility</h2>
        </div>
        <div class="modal-body">
            <ng-container
                *ngIf="calenderAvilablity?.availabilitySettings !== METTING_AVAILABILITY.temporary_unavailable">

                <!-- ================= Date/ Time Details ===============   -->
                <div class="row mb-5 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid">

                    <div class="col-12 col-lg-6 ">
                        <label class="fs-6 fw-bold mb-2 required">Start Date</label>

                        <input class="form-control" formControlName="date"
                            class="form-control form-control-solid flatpickr-input" placeholder="yyyy-mm-dd" name="dp"
                            ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()"
                            [minDate]="minDate" [markDisabled]="isDisabled" />

                        <div class="fv-plugins-message-container invalid-feedback"></div>
                    </div>

                    <div class="col-12 col-lg-6 " *ngIf="calenderAvilablity?.availabilityTimeType !=='hour'">
                        <label class="fs-6 fw-bold mb-2 required">End Date</label>

                        <input class="form-control" formControlName="endDate"
                            class="form-control form-control-solid flatpickr-input" placeholder="yyyy-mm-dd" name="dp"
                            ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()"
                            [minDate]="meetingForm.get('date')?.value" [markDisabled]="isDisabled" />

                        <div class="fv-plugins-message-container invalid-feedback"></div>
                    </div>

                    <ng-container *ngIf="calenderAvilablity?.availabilityTimeType === 'hour'">
                        <div class="col-6">
                            <div class="fv-row mb-9">
                                <label class="fs-6 fw-bold mb-2">Start Time</label>

                                <ng-select [items]="timeSlots" formControlName="timeFrom" [multiple]="false"
                                    placeholder="Select Time" [bindLabel]="'label'" [bindValue]="'value'"
                                    class="meeting-time-select" appendTo="body">
                                    <ng-template ng-label-tmp let-item="item">
                                        <b>{{item.label}}</b>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                        <b>{{item.label}}</b>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>


                        <div class="col-6">
                            <div class="fv-row mb-9">
                                <label class="fs-6 fw-bold mb-2">End Time</label>
                                <ng-select [items]="endTimeSlots" formControlName="timeTo" [multiple]="false"
                                    placeholder="Select End Time" [bindLabel]="'label'" [bindValue]="'value'"
                                    class="meeting-time-select" appendTo="body">
                                    <ng-template ng-label-tmp let-item="item">
                                        <b>{{item.label}}</b>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item" let-index="index">
                                        <b>{{item.label}}</b>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </ng-container>
                </div>

                   <fieldset [disabled]="existingBookedPayment?.data?.found && (existingBookedPayment?.data?.booking?.orderNumber || holdRemainingMessage)" class="m-0 p-0 border-0">
                <!-- ================= BOOKING DURATION ================= -->
                <div class="mb-6" *ngIf="facility.modulePricing"
                    [style.pointer-events]="existingBookedPayment?.data?.found ? 'none' : 'auto'"
                    [attr.aria-disabled]="existingBookedPayment?.data?.found ? 'true' : null">
                    <label class="fw-bold mb-3 d-block">Choose Booking Duration</label>
                    <div class="duration-card" [class.active]="meetingForm.value.bookingDuration === 'hour'"
                        *ngIf="facility.modulePricing.hourlyPricing" (click)="setDuration('hour')">
                        <span>Hourly</span>
                        <span
                            class="price">{{brandDetails.features.payment_currency=='INR'?'Rs.':brandDetails.features.payment_currency}}
                            {{ facility.modulePricing.hourlyPricing }}/-</span>
                    </div>

                    <div class="duration-card" [class.active]="meetingForm.value.bookingDuration === 'day'"
                        *ngIf="facility.modulePricing.dailyPricing" (click)="setDuration('day')">
                        <span>Daily</span>
                        <span
                            class="price">{{brandDetails.features.payment_currency=='INR'?'Rs.':brandDetails.features.payment_currency}}{{
                            facility.modulePricing.dailyPricing }}/-</span>
                    </div>

                    <div class="duration-card" [class.active]="meetingForm.value.bookingDuration === 'week'"
                        *ngIf="facility.modulePricing.weeklyPricing" (click)="setDuration('week')">
                        <span>Weekly</span>
                        <span
                            class="price">{{brandDetails.features.payment_currency=='INR'?'Rs.':brandDetails.features.payment_currency}}
                            {{ facility.modulePricing.weeklyPricing }}/-</span>
                    </div>

                    <div class="duration-card" [class.active]="meetingForm.value.bookingDuration === 'month'"
                        *ngIf="facility.modulePricing.monthlyPricing" (click)="setDuration('month')">
                        <span>Monthly</span>
                        <span
                            class="price">{{brandDetails.features.payment_currency=='INR'?'Rs.':brandDetails.features.payment_currency}}
                            {{ facility.modulePricing.monthlyPricing }}/-</span>
                    </div>
                    <div class="duration-card" [class.active]="meetingForm.value.bookingDuration === 'year'"
                        *ngIf="facility.modulePricing.yearlyPricing" (click)="setDuration('year')">
                        <span>Yearly</span>
                        <span
                            class="price">{{brandDetails.features.payment_currency=='INR'?'Rs.':brandDetails.features.payment_currency}}
                            {{ facility.modulePricing.yearlyPricing }}/-</span>
                    </div>
                </div>

                <!-- ================= BOOKING DETAILS ================= -->
                <div class="mb-6">
                    <label class="fw-bold mb-3 d-block">Select Tenure</label>

                    <div class="detail-card mb-3">
                        <span>Number of {{ meetingForm.value.bookingDuration }}(s)</span>
                        <div class="counter">
                            <button type="button" (click)="changeDays(-1)">−</button>
                            <span>{{ meetingForm.value.numberOfDays }}</span>
                            <button type="button" (click)="changeDays(1)">+</button>
                        </div>
                    </div>

                    <div class="detail-card">
                        <span>Number of {{ facility.capacityUnit }}(s)</span>
                        <div class="counter">
                            <button type="button" (click)="changeSeats(-1)"
                                [disabled]="meetingForm.value.numberOfSeats <= 1">−</button>
                            <span>{{ meetingForm.value.numberOfSeats }}</span>
                            <button type="button" (click)="changeSeats(1)"
                                [disabled]="meetingForm.value.numberOfSeats >= isAvailableSeats"> + </button>
                        </div>
                    </div>
                </div>
                </fieldset>
                <!-- ================= Addons List ================= -->
                <!-- <div class="mb-6" *ngIf="facility.facilityAddons.length">
                   <label class="fw-bold mb-3 d-block">Choose Addons List</label>
                <div *ngFor="let addon of facility.facilityAddons" class="addon-card" [class.selected]="isSelected(addon)">
                
                    <div class="addon-info">
                        <div class="name">{{ addon.itemName }}</div>
                        <div class="price">{{ addon.pricePerUnit ==0 ? 'Free' : '{{brandDetails.features.payment_currency=='INR'?'Rs.':brandDetails.features.payment_currency}} ' + addon.pricePerUnit }}</div>
                    </div>
                
                    <div class="counter">
                        <button type="button" (click)="decrease(addon)" [disabled]="addon.selectedQuantity === 0">−</button>
                
                        <span>{{ addon.selectedQuantity || 0}}</span>
                
                        <button type="button" (click)="increase(addon)"
                            [disabled]="addon.selectedQuantity === addon.quantity">+</button>
                    </div>
                
                </div>
              </div> -->

                <!-- ================= TOTAL PRICE ================= -->
                <div class="border rounded p-4 bg-light mb-6">
                    <div class="d-flex justify-content-between fw-bold align-items-center">
                        <span>Total Price</span>
                        <span class="text-primary fs-5">
                            {{ brandDetails?.features?.payment_currency === 'INR' ? 'Rs.' :
                            brandDetails?.features?.payment_currency }}
                            {{ (meetingForm.get('totalPrice')?.value || 0) | number:'1.2-2':'en-IN' }}/-
                        </span>
                    </div>
                </div>

                <!-- ================= Other Details ===============   -->
                <div class="form-check mb-4">
                    <input class="form-check-input" type="checkbox" formControlName="showSpecialRequest"
                        id="specialRequestToggle" />
                    <label class="form-check-label fw-semibold" for="specialRequestToggle">
                        Add Special Request
                    </label>
                </div>
                <div class="fv-row mb-5 fv-plugins-icon-container" *ngIf="meetingForm.get('showSpecialRequest')?.value">
                    <label class="fs-6 fw-bold mb-2">Special Requests (optional)</label>
                    <textarea formControlName="meetingDescription" class="form-control form-control-solid"
                        placeholder="" rows="5" name="calendar_event_name"></textarea>

                    <div class="fv-plugins-message-container invalid-feedback"></div>
                </div>

                <ng-container
                     *ngIf="noSeatsAvailable && !holdRemainingMessage">
                    <p class="text-center text-danger fw-bold">
                         Facility is temporarily unavailable .
                    </p>
                </ng-container>
                 <ng-container
                     *ngIf="(!facility.isPaymentRequired && showErrorForFreeBookedFacility)">
                    <p class="text-center text-danger fw-bold">
                        Slot already booked. Awaiting admin approval.
                    </p>
                </ng-container>
            </ng-container>
            <ng-container
                *ngIf="calenderAvilablity?.availabilitySettings === METTING_AVAILABILITY.temporary_unavailable">
                <p class="text-center">
                    Bookings for this facility has been temporarily turned off
                </p>
            </ng-container>
            

            <div *ngIf="isFacilityBookedForSelectedSlot()" class="col-md-12 col-12">
                <div class="alert alert-danger p-4">
                    Facility is already booked for this duration.
                </div>
            </div>

        </div>
        <div class="modal-footer flex-center">
              <div *ngIf="holdRemainingMessage" class="col-md-12 col-12">
                <div class="alert alert-warning p-3 mb-0" style="color: #ed7c31;">
                    {{ holdRemainingMessage }}
                </div>
            </div>
            <ng-container
                *ngIf="calenderAvilablity?.availabilitySettings !== METTING_AVAILABILITY.temporary_unavailable ">
                <app-buy-now [label]="existingBookedPayment?.data?.found && holdRemainingMessage ?' Make Payment':'Book Now'" style="width: 100% !important;"
                    [disabled]="noSeatsAvailable|| isModalOpen ||meetingForm.invalid || isFacilityBookedForSelectedSlot() ||(!facility.isPaymentRequired &&  showErrorForFreeBookedFacility)"
                    [ribbonBg]=" ' btn-theme text-white btn btn-primary w-100'" [pass]="calenderAvilablity"
                    (buyClick)="existingBookedPayment.data.found && holdRemainingMessage? this.openCheckoutPage(existingBookedPayment.data.booking.id) : onSubmit()">
                </app-buy-now>
                
            </ng-container>

        </div>
        <div></div>
    </form>
</div>
